
import { granjaApi } from "../../api";
import Swal from "sweetalert2";







export const startLoteDistriXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/distribucion/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}




export const startDistribucionXLote = async(id) => {
    try {
        const { data } = await granjaApi.get(`/distribucion/xlote/${id}`);
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingDistribucion = async(distri) => {
    try {
        // if( lote.id ){
        //     await granjaApi.put(`/lote/${ lote.id }`, lote );
        //     Swal.fire('Exitoso', 'Lote Actualizado', 'success');
        // }else {
        await granjaApi.post('/distribucion/new', distri);
        Swal.fire('Exitoso', 'Distribución Creada', 'success');
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 
